/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Datumversandwillkommensmail2Inputs */

const de__field_datumversandwillkommensmail2 = /** @type {(inputs: _Field_Datumversandwillkommensmail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum Versand Willkommensmail`)
};

/**

* @param {_Field_Datumversandwillkommensmail2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_datumversandwillkommensmail2 = /** @type {((inputs?: _Field_Datumversandwillkommensmail2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Datumversandwillkommensmail2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_datumversandwillkommensmail2(inputs)
});
export { _field_datumversandwillkommensmail2 as "_field_datumVersandWillkommensmail" }